// object definitions
export default new WeakMap();
